import { render, staticRenderFns } from "./SurveyTable.vue?vue&type=template&id=353ed840&scoped=true&"
import script from "./SurveyTable.vue?vue&type=script&lang=js&"
export * from "./SurveyTable.vue?vue&type=script&lang=js&"
import style0 from "./SurveyTable.vue?vue&type=style&index=0&id=353ed840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353ed840",
  null
  
)

export default component.exports